import { NarrowContainer } from "../../app.styled";
import {
  CommentsWrapper,
  ContactButton,
  Essentials,
  EssentialsText,
  EssentialsTitle,
  GalleryWrapper,
  Image,
  Label,
  Labels,
  LeftRow,
  ListText,
  Root,
  Rows,
  SocialIcons,
  Text,
} from "./lot-description-block-mobile.styled";
import main2Jpg from "../../images/_lot-page/main2.jpg";
import main3Jpg from "../../images/_lot-page/main3.jpg";
import main4Jpg from "../../images/_lot-page/main4.jpg";
import videoJpg from "../../images/_lot-page/video.jpg";
import facebookIcon from "../../images/icons/facebook-icon.png";
import twitterIcon from "../../images/icons/twitter-icon.png";
import mailIcon from "../../images/icons/mail-icon.png";
import { Gallery, GalleryImages } from "../../components/gallery/gallery";
import { Player } from "../../components/player/player";
import { galleriesData } from "../../data/galleries-data";
import { BidCard } from "../../components/bid-card/bid-card";
import { CommentsForm } from "../../components/comments-form/comments-form";
import { CommentsList } from "../../components/comments-list/comments-list";
import {BidCardMobile} from "../../components/bid-card/bid-card-mobile";

export const LotDescriptionBlockMobile = () => {
  return (
    <Root>
      <NarrowContainer>
        <Rows>
          <LeftRow>
            <Labels>
              <Label>
                <b>MAKE:</b> Porsche
              </Label>
              <Label>
                <b>Model:</b> 911
              </Label>
              <Label>
                <b>Year:</b> 1990s
              </Label>
              <Label>
                <b>Origin:</b> Germany
              </Label>
            </Labels>
            <div>
              <Essentials>
                <EssentialsTitle>ESSENTIALS</EssentialsTitle>
                <EssentialsText>
                  <b>Seller:</b> <u>Lambo 277</u>
                </EssentialsText>
                <EssentialsText>
                  <b>Location:</b> <u>Wekiva Spring, Florida 32779</u>
                </EssentialsText>
                <div>
                  <div>
                    <b style={{ fontSize: "13px" }}>Listing Details</b>
                  </div>
                  <div>
                    <ListText>
                      • &nbsp;&nbsp;Chassis: ZA9CA05A3KLA12729
                    </ListText>
                    <ListText>
                      • &nbsp;&nbsp;37k Kilometers (~23k Miles) Shown
                    </ListText>
                    <ListText>• &nbsp;&nbsp;5.2-Liter DOHC V12</ListText>
                    <ListText>
                      • &nbsp;&nbsp;Bosch K-Jetronic Fuel Injection
                    </ListText>
                    <ListText>
                      • &nbsp;&nbsp;Five-Speed Manual Transmission
                    </ListText>
                    <ListText>• &nbsp;&nbsp;Black Paint</ListText>
                    <ListText>• &nbsp;&nbsp;Black Leather Upholstery</ListText>
                    <ListText>
                      • &nbsp;&nbsp;Multi-Piece 15” OZ Racing Wheels
                    </ListText>
                    <ListText>
                      • &nbsp;&nbsp;European-Market Front Bumper
                    </ListText>
                    <ListText>• &nbsp;&nbsp;Rear Wing</ListText>
                    <ListText>
                      • &nbsp;&nbsp;Electronic CListTextmate Control
                    </ListText>
                    <ListText>• &nbsp;&nbsp;Alpine CD Stereo</ListText>
                    <ListText>
                      • &nbsp;&nbsp;Power-Operated Windows and Seats
                    </ListText>
                    <ListText>• &nbsp;&nbsp;Gated Shifter</ListText>
                    <ListText>• &nbsp;&nbsp;Collection of Spare Parts</ListText>
                  </div>
                </div>
                <EssentialsText>
                  <b>Private Party or Dealer:</b> Private Party
                </EssentialsText>
                <EssentialsText>
                  <b>Lot:</b> #89782
                </EssentialsText>
              </Essentials>
              <ContactButton blue>CONTACT SELLER</ContactButton>
              <SocialIcons>
                <img src={twitterIcon} alt="twitter" height={50} />
                <img src={facebookIcon} alt="facebook" height={50} />
                <img src={mailIcon} alt="mail" height={25} />
              </SocialIcons>
            </div>
            <Text>
              This 1995 Lamborghini Countach is one of approximately 658
              examples of the 25th Anniversary model built during a three-year
              production run. The car was completed in July 1989 and was
              previously registered in New York, Texas, Florida, and Indiana
              before it was purchased by the seller in 2010. It is finished in
              black over matching leather upholstery, and power comes from a
              5.2-liter DOHC V12 paired with a five-speed manual transmission.
              Equipment includes Bosch K-Jetronic fuel injection, scissor doors,
              a rear wing, a European-market front bumper, multi-piece 15” OZ
              Racing wheels, an Alpine CD stereo, power-operated windows and
              seats, and a gated shifter. This Countach is now offered with a
              collection of spare parts, factory books, literature, service
              records, and a clean Florida title in the seller’s name.
            </Text>
            <Image src={main2Jpg} alt="main2" />
            <Text>
              The Marcello Gandini-penned bodywork was updated by Horacio Pagani
              for the 25th Anniversary edition of the Countach and features
              Kevlar panels with a revised rear bumper, engine lid, rocker
              panels, and air intakes as well as a commemorative emblem on the
              rear fascia. The bodywork is mounted over a tubular steel
              spaceframe and is finished in black. Additional features include
              front fog lights, pop-up headlights, a V-shaped rear wing, and
              NACA ducts aft of the scissor doors. The Carfax report notes an
              accident with another motor vehicle in May 1998. The seller states
              that the US-market front bumper was damaged as a result and
              subsequently replaced with a European-specification unit.
            </Text>
            <Image src={main3Jpg} alt="main3" />
            <Text>
              Introduced as a prototype in 1971, the Countach was designed by
              Bertone’s Marcello Gandini with angular wedge-shaped styling and
              scissor doors. The car features a tubular steel space frame under
              aluminum bodywork as well as NACA ducts aft of the doors and air
              intakes above the rear quarters. The 5000 QV model debuted in 1985
              and utilized Kevlar front and rear deck lids.
            </Text>
            <Image src={main4Jpg} alt="main4" />
            <Text>
              This example is finished in red and features a quad-exit exhaust,
              a black rear bumper, and a V-shaped rear wing. A European-market
              front bumper with inset Carello fog lights was reportedly
              installed by Ultrasmith Systems in 1987 along with side skirts and
              a rotating rear license plate frame. The pop-up headlights can be
              seen raised in the gallery.
            </Text>
            <Gallery exploreAll title="VIDEO" count={2}>
              <Player poster={videoJpg} />
            </Gallery>
            {galleriesData.map((gallery) => (
              <GalleryWrapper key={gallery.title}>
                <Gallery exploreAll title={gallery.title} count={gallery.count}>
                  <GalleryImages>
                    {gallery.images.map((image, index) => (
                      <img
                        key={image}
                        src={image}
                        alt={`${gallery.title} ${index + 1}`}
                      />
                    ))}
                  </GalleryImages>
                </Gallery>
              </GalleryWrapper>
            ))}
            <BidCard />
            <BidCardMobile />
            <CommentsWrapper>
              <Gallery title="COMMENTS" count={12}>
                <CommentsForm />
                <CommentsList />
              </Gallery>
            </CommentsWrapper>
          </LeftRow>
        </Rows>
      </NarrowContainer>
    </Root>
  );
};
